import { Blocker } from 'react-router'
import { BulkActionStore } from '@App/stores/search/bulk-action-store'
import { PaginationBody } from '@Entities/pagination'
import { useBulkActionNavigationBlocker } from '@Components/BulkAction/hooks/useBulkActionNavigationBlocker'

export interface BulkActionNavigation {
    blocker: Blocker
    bulkActionLabel: string | undefined
}

export const useBulkActionNavigation = (
    bulkActionStore: BulkActionStore<string, string> | undefined,
    searchStore: { pagination: PaginationBody },
    labels: Record<string, string>,
    selectionLimit?: number
): BulkActionNavigation => {
    const blocker = useBulkActionNavigationBlocker(bulkActionStore, searchStore, selectionLimit)
    const bulkActionLabel = bulkActionStore?.activeBulkAction ? labels[bulkActionStore.activeBulkAction] : undefined

    return { blocker, bulkActionLabel }
}
